import React, { useEffect, useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { CheckCircle, ArrowLeft } from 'lucide-react';

const SuccessPage = ({ onClose }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get session ID from URL
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');
    
    if (sessionId) {
      // In a real app, you might want to verify the session with your backend
      console.log('Payment successful for session:', sessionId);
    }
    
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-8 h-8 text-green-600" />
            </div>
          </div>
          
          <h1 className="text-2xl font-bold text-slate-900 mb-4">
            Payment Successful!
          </h1>
          
          <p className="text-slate-600 mb-6">
            Your mockups have been added to your account. You can now continue generating professional mockups.
          </p>
          
          <div className="space-y-3 mb-8">
            <div className="flex items-center justify-center gap-2 text-sm text-slate-600">
              <CheckCircle className="w-4 h-4 text-green-500" />
              <span>Mockups added to your account</span>
            </div>
            <div className="flex items-center justify-center gap-2 text-sm text-slate-600">
              <CheckCircle className="w-4 h-4 text-green-500" />
              <span>Access to all device types and styles</span>
            </div>
            <div className="flex items-center justify-center gap-2 text-sm text-slate-600">
              <CheckCircle className="w-4 h-4 text-green-500" />
              <span>Start generating immediately</span>
            </div>
          </div>
          
          <Button
            onClick={onClose}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to App
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default SuccessPage;
